import "../css/booksfooter.css";

export default function Books() {
    return (
        <div className="books-center-button-container">
                <div className="books-intro">
                    B.T. Swami’s teachings will undoubtedly continue through his unique books and through the lives of those who imbibe his message.
                </div>
                <div className="books-primary-button-container">
                    <a href="/books">
                        <button className="books-primary-button">Purchase Books</button>
                    </a>
                </div>
        </div>
    );
}